import { render, staticRenderFns } from "./Confirm2FA.htm?vue&type=template&id=5401a0da&scoped=true&"
import script from "./Confirm2FA.js?vue&type=script&lang=js&"
export * from "./Confirm2FA.js?vue&type=script&lang=js&"
import style0 from "./Confirm2FA.scss?vue&type=style&index=0&id=5401a0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5401a0da",
  null
  
)

export default component.exports